/**
 *
 * RouteControls
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { Button } from 'react-bootstrap';
import { STATUS_EDITING } from 'containers/EditService/constants';
import withUiControl from 'containers/UiControl/withUiControl';
import withRoutes from 'containers/Routes/withEntity';
import withUser from 'containers/User/withUser';
import ImportGpx from 'containers/ImportGpx';
import Switch from 'components/Switch';
import Spinner from 'components/Spinner';
import { useMinWidth } from 'utils/useMinSize';

import messages from './messages';
import DistanceFilters from './DistanceFilters';

function RouteControls(props) {
  const {
    uiToggle,
    uiChange,
    showRoutes,
    onlyOwnRoutes,
    distanceFilter,
    routes,
    user,
    editing,
    intl,
    onChange,
  } = props;
  const isLarge = useMinWidth();
  const manageRoutes = () => {
    uiChange('showRoutes')(false);
    window.location.hash = '#routes';
  };
  const importGpxTitle =
    editing === STATUS_EDITING
      ? intl.formatMessage(messages.disabled)
      : undefined;
  return (
    <React.Fragment>
      <Spinner show={showRoutes && routes.loading}>
        <Switch
          value={showRoutes}
          onChange={uiToggle('showRoutes')}
          id="show-routes-switch"
        >
          <FormattedMessage {...messages.showRoutes} />
        </Switch>
      </Spinner>
      {user.api && (
        <Switch
          value={onlyOwnRoutes}
          onChange={uiToggle('onlyOwnRoutes')}
          id="only-own-routes-switch"
          size="sm"
        >
          <FormattedMessage {...messages.onlyOwnRoutes} />
        </Switch>
      )}
      {isLarge && (
        <Switch
          value={distanceFilter}
          onChange={uiToggle('distanceFilter')}
          id="distance-filter-switch"
          size="sm"
        >
          <FormattedMessage {...messages.distanceFilter} />
        </Switch>
      )}
      {isLarge && distanceFilter && <DistanceFilters />}
      {user.api && (
        <Button bsStyle="default" onClick={manageRoutes}>
          <FormattedMessage {...messages.manageRoutes} />
        </Button>
      )}
      <ImportGpx
        disabled={editing === STATUS_EDITING}
        className="btn btn-default"
        title={importGpxTitle}
        onChange={onChange}
      />
    </React.Fragment>
  );
}

RouteControls.propTypes = {
  showRoutes: PropTypes.bool,
  onlyOwnRoutes: PropTypes.bool,
  distanceFilter: PropTypes.bool,
  editing: PropTypes.number,
  routes: PropTypes.object,
  user: PropTypes.object,
  uiToggle: PropTypes.func.isRequired,
  uiChange: PropTypes.func.isRequired,
  intl: intlShape,
  onChange: PropTypes.func,
};

const uiControls = [
  'onlyOwnRoutes',
  'showRoutes',
  'distanceFilter',
  'routesMin',
  'routesMax',
];

export default compose(
  withRoutes,
  withUser,
  injectIntl,
  withUiControl(uiControls),
)(RouteControls);
